import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useTaskActionsContext } from './Context'
import { useDeleteProjectTask } from '@ztechapps/project.common'
import { useConfirmDialog, useError, useHistory } from '@ztechapps/common.hook'
import type { Project, RouteDef, Task } from '@ztechapps/common.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'

export const useDeleteTask = () => {
  const { projectId, taskId } = useTaskActionsContext()
  const history = useHistory()
  const projectRoute = useInject<RouteDef>(WebuiIocKey.routes.projectItem)

  const [deleteTask, { loading, error }] = useDeleteProjectTask()
  useError(error)

  const { onConfirm } = useConfirmDialog({
    title: 'Delete Task',
    text: 'Are you sure you want to delete this task?',
    confirmed: async () => {
      await deleteTask({
        tasks: [{ _id: taskId } as Task],
        project: { _id: projectId } as Project,
      })

      //after successful, delete we navigate to the project details
      history.push(projectRoute.altPath({ _id: projectId }))
    },
  })

  return {
    onConfirmDelete: onConfirm,
    error,
    loading,
  }
}

/**
 * NOTE:
 * we used here the hooks from the project,
 * i think it still ok for now, the web-ui project has depdendency on the common project (task)
 * @constructor
 */
export const DeleteProjectTasks = () => {
  const { onConfirmDelete, loading } = useDeleteTask()
  const { canEdit, disabledReason } = useTaskActionsContext()

  return (
    <BusyButton
      variant="danger"
      isBusy={loading}
      text="Delete"
      title="Delete the task."
      disabled={!canEdit}
      disabledReason={canEdit ? undefined : disabledReason}
      onClick={onConfirmDelete}
    />
  )
}
